<card>
  <form [formGroup]="form" class="form" (submit)="handleSubmit($event)">
    <div style="display: flex; justify-content: space-between">
      <div class="field is-narrow">
        <label
          class="label"
          translationEditableDirective="NAME"
          style="font-size: 13px"
          [ngClass]="{
            'has-text-danger': validationErrors.has('name')
          }"
          >{{ 'NAME' | translate }}</label
        >
        <div class="control">
          <input
            class="input is-small"
            formControlName="name"
            type="text"
            [ngClass]="{ 'is-danger': validationErrors.has('name') }"
          />
        </div>
        <p class="help is-danger" *ngIf="validationErrors.has('name')">
          {{ validationErrors.get('name') }}
        </p>
      </div>
      <button
        type="button"
        class="button is-info is-small"
        (click)="addItem()"
        style="margin-top: 30px"
        translationEditableDirective="ADD_ITEM"
      >
        {{ 'ADD_ITEM' | translate }}
      </button>
    </div>

    <div formArrayName="items">
      <div
        *ngFor="let item of items.controls; let i = index"
        [formGroupName]="i"
        class="box"
        style="margin-bottom: 0.5rem; padding: 10px"
      >
        <div style="display: flex; justify-content: space-between">
          <div
            class="field"
            style="display: flex; align-items: center; margin: 0"
          >
            <label
              class="label"
              style="font-size: 13px; margin-right: 5px; margin-bottom: 0"
              [ngClass]="{
                'has-text-danger': validationErrors.has(
                  'items.' + i + '.propertyType'
                )
              }"
              ><span translationEditableDirective="PROPERTY_TYPE">{{
                'PROPERTY_TYPE' | translate
              }}</span
              >:</label
            >
            <div class="control is-relative">
              <input
                class="input is-small"
                readonly
                type="text"
                formControlName="propertyType"
                style="cursor: default; width: 400px"
                [ngClass]="{
                  'is-danger': validationErrors.has(
                    'items.' + i + '.propertyType'
                  )
                }"
              />
              <button
                class="button p-1"
                type="button"
                (click)="isPropertyTypesOpen = true; propertyTypeRowIndex = i"
                style="
                  position: absolute;
                  top: 0px;
                  right: 8px;
                  height: auto;
                  border: 0;
                  background: transparent;
                  outline: none !important;
                  box-shadow: none !important;
                "
              >
                <span class="icon is-small">
                  <i class="fa-regular fa-pen-to-square"></i>
                </span>
              </button>
            </div>
          </div>
          <div style="padding-top: 5px">
            <button
              type="button"
              class="button is-info is-small mr-2"
              (click)="addSlot(i)"
              translationEditableDirective="ADD_SLOT"
            >
              {{ 'ADD_SLOT' | translate }}
            </button>
            <button
              type="button"
              class="button is-danger is-small"
              (click)="removeItem(i)"
            >
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>
        </div>

        <div formArrayName="slots">
          <div
            *ngFor="let slot of item.get('slots').controls; let j = index"
            [formGroupName]="j"
            class="box"
            style="
              display: flex;
              justify-items: center;
              gap: 10px;
              padding: 10px;
              margin-bottom: 0;
              margin-top: 0.5rem;
            "
          >
            <div
              class="field"
              style="display: flex; align-items: center; margin: 0"
            >
              <label
                class="label"
                style="
                  font-size: 13px;
                  margin: 0;
                  padding: 0;
                  margin-right: 5px;
                "
                [ngClass]="{
                  'has-text-danger': validationErrors.has(
                    'items.' + i + '.slots.' + j + '.name'
                  )
                }"
                ><span translationEditableDirective="NAME">{{
                  'NAME' | translate
                }}</span
                >:</label
              >
              <input
                class="input is-small"
                formControlName="name"
                type="text"
                [ngClass]="{
                  'is-danger': validationErrors.has(
                    'items.' + i + '.slots.' + j + '.name'
                  )
                }"
              />
            </div>
            <div
              class="field"
              style="display: flex; align-items: center; margin: 0"
            >
              <label
                class="label"
                style="
                  font-size: 13px;
                  padding: 0;
                  margin-bottom: 0;
                  margin-right: 5px;
                "
                [ngClass]="{
                  'has-text-danger': validationErrors.has(
                    'items.' + i + '.slots.' + j + '.type'
                  )
                }"
                ><span translationEditableDirective="TYPE">{{
                  'TYPE' | translate
                }}</span
                >:</label
              >
              <select
                name="calculationType"
                class="input is-small"
                [translationEditableModalDirective]="slotTypeKeys"
                [translationEditableModalDirectiveDefaults]="slotTypeDefaults"
                [ngClass]="{
                  'is-danger': validationErrors.has(
                    'items.' + i + '.slots.' + j + '.type'
                  )
                }"
                formControlName="type"
                style="width: 100px"
              >
                <option value="">{{ 'TYPE' | translate }}</option>
                <option *ngFor="let type of slotTypes" [value]="type.name">
                  {{
                    type.trnKey | translate : { defaultValue: type.defaultName }
                  }}
                </option>
              </select>
            </div>
            <div
              class="field"
              style="display: flex; align-items: center; margin: 0"
            >
              <label
                class="label"
                style="
                  font-size: 13px;
                  margin: 0;
                  padding: 0;
                  margin-right: 5px;
                "
                [ngClass]="{
                  'has-text-danger': validationErrors.has(
                    'items.' + i + '.slots.' + j + '.rangeStart'
                  )
                }"
                ><span translationEditableDirective="RANGE_START">{{
                  'RANGE_START' | translate
                }}</span
                >:</label
              >
              <number-input
                step="0.01"
                [inputClass]="
                  validationErrors.has(
                    'items.' + i + '.slots.' + j + '.rangeStart'
                  )
                    ? 'input is-small is-danger'
                    : 'input is-small'
                "
                formControlName="rangeStart"
                style="width: 60px"
              />
            </div>
            <div
              class="field"
              style="
                display: flex;
                align-items: center;
                margin: 0;
                padding: 0;
                margin-right: 5px;
              "
            >
              <label
                class="label"
                style="font-size: 13px; margin: 0; margin-right: 5px"
                [ngClass]="{
                  'has-text-danger': validationErrors.has(
                    'items.' + i + '.slots.' + j + '.rangeEnd'
                  )
                }"
                ><span translationEditableDirective="RANGE_END">{{
                  'RANGE_END' | translate
                }}</span
                >:</label
              >
              <number-input
                step="0.01"
                [inputClass]="
                  validationErrors.has(
                    'items.' + i + '.slots.' + j + '.rangeEnd'
                  )
                    ? 'input is-small is-danger'
                    : 'input is-small'
                "
                formControlName="rangeEnd"
                style="width: 60px"
              />
            </div>
            <div
              class="field"
              style="
                display: flex;
                align-items: center;
                margin: 0;
                padding: 0;
                margin-right: 5px;
              "
            >
              <label
                class="label"
                style="font-size: 13px; margin: 0; margin-right: 5px"
                [ngClass]="{
                  'has-text-danger': validationErrors.has(
                    'items.' + i + '.slots.' + j + '.value'
                  )
                }"
                ><span translationEditableDirective="VALUE">{{
                  'VALUE' | translate
                }}</span
                >:</label
              >
              <number-input
                formControlName="value"
                step="0.01"
                [inputClass]="
                  validationErrors.has('items.' + i + '.slots.' + j + '.value')
                    ? 'input is-small is-danger'
                    : 'input is-small'
                "
                style="width: 60px"
              />
              <span
                class="is-size-6 ml-2"
                *ngIf="item.get('slots').at(j).value.type === 'PROGRESSIVE'"
                >%</span
              >
              <span
                class="is-size-6 ml-2"
                *ngIf="item.get('slots').at(j).value.type === 'FIXED'"
                >{{ settings.SETTINGS_UNITS_CURRENCY_SYMBOL }}</span
              >
            </div>
            <div class="ml-auto" style="padding-top: 5px">
              <button
                type="button"
                class="button is-danger is-small"
                (click)="removeSlot(i, j)"
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</card>

<div class="field is-grouped px-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SUBMIT"
      (click)="handleSubmit($event)"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/form-postprocessors']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>

<property-type-modal
  (onClose)="isPropertyTypesOpen = false"
  (onSave)="handlePropertyTypeChange($event)"
  [isOpen]="isPropertyTypesOpen"
></property-type-modal>
